import { ViewPageInterface } from '../../../domain/ViewDossier/ViewPage'
import PresentationPage from './partials/PresentationPage'
import { Tab, TabsLikeWizard } from '../tab/Tab'
import InvalidElement from '../../../domain/Folder/InvalidElementInterface';

interface Props {
  state: string | null
  viewPages: ViewPageInterface[],
  invalidElements: InvalidElement[]
  onInvalidateToggle: (
    isInvalid: boolean,
    elementId: string,
    comment: string,
    blockId: string,
    receiptId: string | null,
    value: string | null,
    pageId: string,
  ) => void
  onCommentChange: (elementId: string, receiptId: string|null, comment: string) => void
}

const PresentationDossier = ({ state, viewPages, invalidElements, onInvalidateToggle, onCommentChange }: Props): JSX.Element => {
  return (
    <div className="box-elevations box-elevations--base u-mxAuto u-pxm u-mbxlr">
      <TabsLikeWizard classes='wizzard no-max-width'>
        {viewPages.map((page: ViewPageInterface) => {
          return <Tab key={page.id} label={page.name}>
            <PresentationPage page={page} state={state} invalidElements={invalidElements} onInvalidateToggle={onInvalidateToggle} onCommentChange={onCommentChange} />
          </Tab>
        })}
      </TabsLikeWizard>
    </div>
  );
};

export default PresentationDossier
